import {createContext, useContext} from "react";
import {User} from "../common/StorageHelper";

interface AuthContextType {
    user?: User | null;
    setUser: (user: User | null) => void;
}

export const AuthContext = createContext<AuthContextType>(
    {} as AuthContextType
);

export const useAuth = () => {
    return useContext(AuthContext)
}
